import produce from "immer";
import { RootAction, getType } from "typesafe-actions";
import {
  getSessionUser,
  storeSessionKey,
  acceptBuyerTos,
} from "@/global/actions";
import { DigitalToolsUser } from "@/types";

export interface SessionReducerState {
  sessionKey?: string;
  userRequestStatus: RequestStatus;
  user?: DigitalToolsUser;
}

export enum RequestStatus {
  initial = "INITIAL",
  request = "REQUEST",
  success = "SUCCESS",
  failure = "FAILURE",
}

export const sessionReducer = produce(
  (draft: SessionReducerState, action: RootAction) => {
    switch (action.type) {
      case getType(storeSessionKey):
        draft.sessionKey = action.payload.sessionKey;
        break;
      case getType(getSessionUser.request):
        draft.userRequestStatus = RequestStatus.request;
        break;
      case getType(getSessionUser.success):
        draft.userRequestStatus = RequestStatus.success;
        draft.user = action.payload.user;
        break;
      case getType(getSessionUser.failure):
        draft.userRequestStatus = RequestStatus.failure;
        break;
      case getType(acceptBuyerTos):
        draft.user = draft.user && {
          ...draft.user,
          hasBuyerTosAccepted: true,
          hasBuyerTosLatestAccepted: true,
        };
        break;
    }
  },
  {
    userRequestStatus: RequestStatus.initial,
  },
);
